import React, { useState, useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ErrorBoundary } from 'wsm-error-boundary';
import { useLabels } from 'wsm-common-data';
import { CommonModal } from 'wsm-common-modal';
import DetailedSpecs from '../components/DetailedSpecs';

const WidgetContainer = (props) => {
	const { equipment, prefs, widgetInfo } = props;
	const labels = useLabels();
	const [isModalOpen, setIsModalOpen] = useState(false);

	const displayInModal = prefs?.displayDetailedSpecsInModal === 'true';

	useLayoutEffect(() => {
		if (!displayInModal || !widgetInfo?.windowId) return undefined;

		const appRoot = document.getElementById(
			`${widgetInfo.windowId}-app-root`
		);
		if (!appRoot) return undefined;

		const heading = appRoot.querySelector('.widget-heading');
		if (heading) {
			heading.style.display = 'none';
		}

		// Force open any collapse wrapper so the modal trigger link is visible
		const collapseContent = appRoot.querySelector('.collapse-content');
		if (collapseContent) {
			collapseContent.classList.add('in');
		}
		appRoot.classList.remove('collapse-container');

		return () => {
			if (heading) heading.style.display = '';
			if (collapseContent) collapseContent.classList.remove('in');
			appRoot.classList.add('collapse-container');
		};
	}, [displayInModal, widgetInfo?.windowId]);

	const { specCategories = [], specification = [] } = equipment || {};

	if (!equipment) {
		return null;
	}

	if (displayInModal) {
		const labelKey =
			prefs?.detailedSpecsModalTitle || 'DETAILED_SPECS_MODAL';
		const linkText = labels?.get?.(labelKey) || labelKey || 'View All Features & Specs';

		return (
			<ErrorBoundary newRelicPageAction="WS DETAILED SPECS ERROR BOUNDARY">
				<div className="detailed-specs-modal-trigger">
					<div className="detailed-specs-container">
						<button
							type="button"
							className="btn btn-link px-0"
							onClick={() => setIsModalOpen(true)}
						>
							{linkText}
						</button>
					</div>
				</div>
				<CommonModal
					title={linkText}
					isOpen={isModalOpen}
					width="responsive"
					onClose={() => setIsModalOpen(false)}
					ariaLabel={linkText}
				>
					<DetailedSpecs
						specCategories={specCategories}
						specification={specification}
						widgetInfo={widgetInfo}
						prefs={{ ...prefs, toggleCollapse: 'false' }}
						isModal
					/>
				</CommonModal>
			</ErrorBoundary>
		);
	}

	return (
		<ErrorBoundary newRelicPageAction="WS DETAILED SPECS ERROR BOUNDARY">
			<DetailedSpecs
				specCategories={specCategories}
				specification={specification}
				widgetInfo={widgetInfo}
				prefs={prefs}
			/>
		</ErrorBoundary>
	);
};

WidgetContainer.propTypes = {
	equipment: PropTypes.shape({
		specCategories: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
		specification: PropTypes.arrayOf(PropTypes.shape({})).isRequired
	}),
	prefs: PropTypes.objectOf(PropTypes.string),
	widgetInfo: PropTypes.shape({
		windowId: PropTypes.string.isRequired,
		widgetName: PropTypes.string.isRequired
	}).isRequired
};

WidgetContainer.defaultProps = {
	equipment: null,
	prefs: {}
};

const mapStateToProps = (state) => ({
	prefs: state.prefs,
	equipment: state.equipment,
	widgetInfo: state.widgetInfo
});

const mapDispatchToProps = (_dispatch) => ({});

const Widget = connect(mapStateToProps, mapDispatchToProps)(WidgetContainer);

export default Widget;
